





































































import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import Debug from "@/components/utility/Debug.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { InvoiceStatusEnum } from "@/lib/enum/invoice-status.enum";
import { IGroupTypeEntityCreateDialog } from "@/lib/utility/group/interface/group-type-entity-create-dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { DocumentDirectionEnum, IInvoice, Invoice } from "@/models/invoice.entity";
import { IReference, Reference } from "@/models/reference.entity";
import { SignDocument } from "@/models/sign-document.entity";
import { currencySymbolMap } from "@/store/mapper/currency-symbol.map";
import { IRefSuggestion } from "@/store/modules/fleet-aggregation.store";
import { GroupModule } from "@/store/modules/group.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import CostCardDocuments from "../cost/CostCardDocuments.vue";
import GroupTypeSelectionDetailComponent from "../group/GroupTypeSelectionDetailComponent.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import FileInputMixin from "../utility/FileInputMixin.vue";
import MDetailViewGrid from "../utility/mmmint/MDetailViewGrid.vue";
import RefsSelect from "../utility/RefsSelect.vue";
import SelectEntity from "../utility/SelectEntity.vue";
import InvoiceCreateDialogPartyForm from "./InvoiceCreateDialogPartyForm.vue";
import InvoiceInboundForm from "./InvoiceInboundForm.vue";
import InvoicePartyForm from "./InvoicePartyForm.vue";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { CompanyModule } from "@/store/modules/company.store";
import { ReportPaginationModule } from "@/store/modules/report-pagination.store";

export enum CreateInvoiceWindow {
  START,
  CREATE
}

@Component({
  components: {
    ConfirmActionDialog,
    CostCardDocuments,
    RefsSelect,
    SelectEntity,
    Debug,
    InvoiceCreateDialogPartyForm,
    InvoiceInboundForm,
    MDetailViewGrid,
    GroupTypeSelectionDetailComponent,
    InvoicePartyForm,
    DropAreaMulti
  },
  filters: {}
})
export default class CreateInvoiceInboundDialog extends mixins(FileInputMixin, RulesMixin, PermissionMixin)
  implements IGroupTypeEntityCreateDialog {
  readonly currencySymbolMap = currencySymbolMap;
  readonly CurrencyEnum = CurrencyEnum;
  readonly InvoiceStatusEnum = InvoiceStatusEnum;
  readonly Invoice = Invoice;

  CreateInvoiceWindow = CreateInvoiceWindow;

  @Ref("invoiceForm") invoiceForm!: InvoiceInboundForm;

  @Ref("costCardDocuments")
  costCardDocuments!: CostCardDocuments;

  @Prop()
  partnerId!: string;

  @Prop({ default: "create" })
  text!: string;

  @Prop()
  hideButton!: boolean;

  /**
   * ID of invoice group to preselect
   */
  @Prop()
  groupId?: string;

  @Prop({ default: () => [] })
  refs!: IReference[];

  @Prop()
  buyerRef?: IReference;

  @Prop()
  sellerRef?: IReference;

  @Prop()
  vehicleId?: string;

  @Prop()
  fleetId?: string;

  @Prop()
  reportId?: string;

  @Prop()
  documentId?: string;

  step = CreateInvoiceWindow.START;

  isDialogActive = false;

  isLoading = false;

  isValid = false;

  invoice: IInvoice | null = null;
  files: File[] = [];

  pdf = "";

  @Watch("files")
  onWatchFiles(files: File[]) {
    if (files) {
      this.pdf = URL.createObjectURL(files[0]);
      this.suggestCleanName();
    }
  }

  suggestCleanName() {
    if (this.files && this.files.length > 0 && this.invoice && this.files[0].name.endsWith(".pdf")) {
      this.invoice.number = this.files[0].name
        .substring(0, this.files[0].name.length - 4)
        .replace(/\s+/g, "") // Remove whitespaces
        .replace(/[^\w\d-]/g, ""); // Remove special characters except alphanumeric and hyphen
    }
  }

  get report() {
    if (!this.reportId) {
      return undefined;
    }

    return ReportPaginationModule.maps.id.get(this.reportId)[0];
  }

  get coverageType() {
    return this.report?.coverageType;
  }

  get fileLength() {
    return this.files.length;
  }

  get dialogStep() {
    switch (this.step) {
      case CreateInvoiceWindow.START:
        return {
          title: $t("invoice.createInvoice"),
          subtitle: "",
          leftText: $t("close"),
          rightText: $t("next"),
          leftClick: this.close,
          rightClick: () => this.step++,
          rightDisabled: this.fileLength !== 1,
          fullscreen: false
        };

      case CreateInvoiceWindow.CREATE:
        return {
          title: $t("invoice.createInvoice"),
          subtitle: "",
          leftText: $t("back"),
          rightText: $t("create"),
          leftClick: () => this.step--,
          rightClick: this.create,
          rightDisabled: !this.isValid,
          fullscreen: true
        };

      default:
        return {
          title: $t("invoice.createInvoice"),
          subtitle: "",
          leftText: $t("close"),
          rightText: $t("create"),
          leftClick: this.close,
          rightClick: this.create,
          rightDisabled: !this.isValid
        };
    }
  }

  get partner() {
    return PartnerModule.partner;
  }

  get suggested(): IRefSuggestion[] {
    return [];
  }

  get groups() {
    return GroupModule.filteredAndSorted;
  }

  startDrag() {
    this.isDrag = true;
  }

  endDrag() {
    this.isDrag = false;
  }

  open(step?: CreateInvoiceWindow) {
    this.invoice = new Invoice({
      status: InvoiceStatusEnum.DRAFT,
      direction: DocumentDirectionEnum.INBOUND,
      groupId: this.groupId,
      partnerId: this.partnerId,
      buyer: CompanyModule.partner?.invoiceParty,
      refs: this.refs,
      currency: CurrencyEnum.EUR,
      vehicleId: this.vehicleId,
      fleetId: this.fleetId,
      reportId: this.reportId,
      documentId: this.documentId,
      lineItems: []
    });

    this.suggestCleanName();

    this.isDialogActive = true;

    this.step = step ?? CreateInvoiceWindow.START;
  }

  close() {
    this.isDialogActive = false;
    this.step = CreateInvoiceWindow.START;
    this.files = [];
    this.pdf = "";
    this.invoice = null;
  }

  async create() {
    if (!this.invoice) {
      throw new Error("Missing invoice");
    }

    try {
      this.isLoading = true;
      this.isDialogActive = true;

      const refs = [];
      if (this.reportId) {
        refs.push(new Reference({ refId: this.reportId, refType: ResourceEnum.REPORT }));
      }

      if (this.files && this.files.length >= 1) {
        const signDocument = new SignDocument({
          name: this.files[0].name,
          title: this.files[0].name,
          isTemplate: false,
          folder: "/invoice/",
          refs: refs,
          file: this.files[0],
          partnerId: this.partnerId
        });

        await signDocument.create();

        this.invoice.document = signDocument;
        this.invoice.documentId = signDocument.id;
      }

      await this.invoice.create();

      this.$emit("created", this.invoice);
      this.$toast.success("👍");
      this.close();
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }
}
